import dayjs from 'dayjs'
import 'dayjs/locale/ar'
import 'dayjs/locale/de'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/it'
import 'dayjs/locale/pt.js'
import 'dayjs/locale/tr'

const lang = navigator.language || 'en'

export const getDateFromTimeStamp = (timeStamp: number): string =>
  timeStamp ? dayjs.unix(timeStamp).locale(lang).format('DD MMM YYYY') : ''
